import { render, staticRenderFns } from "./newtable.vue?vue&type=template&id=cbd8397a&"
import script from "./newtable.vue?vue&type=script&lang=js&"
export * from "./newtable.vue?vue&type=script&lang=js&"
import style0 from "./newtable.vue?vue&type=style&index=0&id=cbd8397a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports